const RoleKeys = {
    Administrator: 'Administrator',
    Manager: 'Manager',
    User: 'User',
} as const;

export type TRoleKey = keyof typeof RoleKeys;

export default RoleKeys;